import $ from "jquery";

class Forms {
    constructor() {

    }
}

export default Forms;